<!--
	<div class="dashboard container-fluid" [hidden]="groupPortalDataService.groupList.groupNumber == null">
    <div class="row groupComponentHeading">
-->

<div class="dashboard container-fluid" [hidden]="groupPortalDataService.groupList.groupNumber == null">
    <div class="groupComponentHeading">
        <div class="col-6 members">Dashboard</div>
        <!-- <div class="col-3 filter"></div>
		<div class="col-3 processPayment"></div> -->
    </div>

    <!-- <div class="mainDashComponenents d-flex flex-wrap w-100 h-100 justify-content-around"></div> -->
    <div class="mainDashComponenents d-flex flex-wrap flex-md-nowrap">
        <div class="w-100 flex-fill mr-3 mb-3 p-4 border align-items-stretch">
            <provider-status-dashboard [mbrCount]="groupPortalDataService.gpdsMemberCounts"
                [showChart]="groupPortalDataService.showChart"
                [groupList]="groupPortalDataService.groupList"></provider-status-dashboard>
        </div>
        <div class="w-100 flex-fill ml-md-3 mr-3 mb-md-3 p-4 border align-items-stretch">
            <group-info-dashboard [groupList]="groupPortalDataService.groupList"
                [groupInfoDoneProcessing]="groupPortalDataService.groupInfoDoneProcessing"></group-info-dashboard>
        </div>
    </div>
    <div class="mainDashComponenents d-flex flex-wrap flex-md-nowrap">
        <div class="w-100 flex-fill mr-3 mt-3 p-4 border align-items-stretch">
            <payment-methods-dashboard [paymentMethods]="groupPortalDataService.groupList.paymentTypes"
                [paymentMethodDoneProcessing]="groupPortalDataService.paymentMethodDoneProcessing"></payment-methods-dashboard>
        </div>
        <div class="w-100 flex-fill ml-md-3 mr-3 mt-3 p-4 border align-items-stretch">
            <invoices-dashboard [groupInvoices]="groupPortalDataService.groupList.groupInvoices"
                [invoicesDoneProcessing]="groupPortalDataService.invoicesDoneProcessing"></invoices-dashboard>
        </div>
    </div>
</div>